<template>

  <div>
    <div class="bold-text mb-2" v-if="displayLabel">
      {{ label }}
    </div>

    <div class="d-flex image-container">

      <img
        :style="'object-fit: ' + objectFit + '; max-width: ' + maxWidth + '; max-height: ' + maxHeight + '; cursor: ' + (zoomOnClick? 'pointer': '') + ';'"
        :src="fileUrl(src)"
        @click="zoomOnClick? zoomOnPicture(fileUrl(src)): null" alt="image">

      <zoom-on-image v-if="zoomOnImageSrc !== null"
                     :src="zoomOnImageSrc"
                     @didCloseZoomOnImage="didCloseZoomOnPicture"/>
    </div>
  </div>

</template>

<script>

import ZoomOnImage from "./ZoomOnImage.vue";

export default {

  name: 'ShowImageField',
  components: {ZoomOnImage},

  data() {
    return {
      zoomOnImageSrc: null
    }
  },

  props: {
    src: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    objectFit: {
      type: String,
      default: 'contain'
    },
    maxWidth: {
      type: String,
      default: '100%'
    },
    maxHeight: {
      type: String,
      default: null
    },
    zoomOnClick: {
      type: Boolean,
      default: false
    }
  },

  computed: {

    fileUrl () {
      return fileUrl => process.env.SERVER_URL + fileUrl
    }

  },

  methods: {

    zoomOnPicture(imageSrc) {
      this.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnPicture() {
      this.zoomOnImageSrc = null
    }

  }

}

</script>

<style scoped>

img {
  margin-left: auto;
  margin-right: auto;
  aspect-ratio: 16/9;
}

.image-container {
  border: var(--main-grey) 1px solid;
  border-radius: var(--main-border-radius);
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/showImageField.vue